import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {MenuItem} from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class NavigationResolver {
  constructor(private readonly router: Router) {
  }

  buildBreadcrumbs(): MenuItem[] {
    const root = this.router.routerState.snapshot.root;
    const items: MenuItem[] = [];

    const homeRoute = this.router.config.find(route => route.path === '' && route.redirectTo);
    items.push({
      icon: 'pi pi-home',
      routerLink: homeRoute?.redirectTo ?? '/'
    });

    let url = '';
    let current: ActivatedRouteSnapshot | null = root;

    while (current) {
      const hasOwnContent = current.routeConfig?.component && !current.firstChild?.routeConfig?.component;
      const isLeafRoute = !current.firstChild;
      const hasTitle = current.routeConfig?.title && current.url.length;

      if (hasTitle && (hasOwnContent || isLeafRoute)) {
        const segment = current.url.map(u => u.path).join('/');
        url += '/' + segment;

        items.push({
          label: String(current.routeConfig!.title),
          routerLink: url
        });
      } else if (current.url.length) {
        const segment = current.url.map(u => u.path).join('/');
        url += '/' + segment;
      }

      current = current.firstChild ?? null;
    }

    return items;
  }
}
